module.exports = __webpack_public_path__ + "img/rent.1edf4847.jpg";